import React, { useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import useStores from 'hooks/use-store';
import { LaneContext } from 'components/project/LaneWrapper';
import { useResponsive, useBidBlockDetails, useFocus, useTheme } from 'hooks';
import { Icon } from '../../shared';
import SellerTools from './SellerTools';
// import NewSwipeButton from './NewSwipeButton';
import { DoubleTapButton } from './DoubleTapButton';

import {ElaneBidDetails} from "../ELaneBidDetails";

import {
  BidButton,
  TimerCircle,
  ContentWrapper,
  DetailsContainer,
  HighBid,
  HighBidLabel,
  HighBidWrapper,
  InputButtonGroup,
  TakeButton,
  NoBids,
  ProxyBidButton,
  Track,
  TrackKey,
  TrackValue,
  FullTrackValue,
} from './Styles';

const BidDetails = ({auctionId}) => {
  const {
    MultiAuctionStore: {user},
    AuctionStore: {
      connected, laneStatusMap, auctionInfo, networkConnected, bidderNumber
    },
    BidStore: {
      auction, watchList, proxies
    },
    UIStore: {
      placeLiveBid, setSellerAction, setTempSellerAction, clearSellerAction, scrollPosition, isFullViewLayout
    },
    VirtualAuctionStore: {
      isCountdownActive,
      isBonusTimeActive,
      duration,
      countdownKey
    }
  } = useStores(auctionId);

  const { object: theme, isLight } = useTheme();
  const isLightTheme = isLight('white');

  const { isMobileView } = useResponsive();
  const { laneID } = useContext(LaneContext);
  const { allowProxyBidding } = auctionInfo;
  const [takeAmountRef, setTakeAmountRefFocus] = useFocus();

  const productItem = auction[laneID]?.productItem;
  const { productName } = productItem;
  const isVirtual = auction[laneID]?.isVirtual;

  const lanePaused = laneStatusMap.get(laneID).laneStatusName === 'Paused';
  const {
    decisionStatus,
    abbrevBidderName,
    tempSellerAction,
    sellerAction,
    BidButtonLabelLogic,
    disabledButton,
    DisableTakeSubmit,
    hasProxyBid,
    highBidAmtTakeClick,
    isSeller,
    isWatched,
    myProxyBidAmount,
    myProxyBidIsActive,
    onTakesKeyUp,
    onTakesKeyPress,
    formattedReserve,
    state,
    TakesValidationMessages,
    tempTakeAmount,
    winningBidderName,
    wasOutbid
  } = useBidBlockDetails({
    allowProxyBidding,
    auctionLane: auction[laneID],
    laneID,
    laneStatusMap,
    proxies,
    setSellerAction,
    user,
    watchList,
    takeAmountRef,
    setTakeAmountRefFocus,
    networkConnected,
    bidderNumber
  });
  const laneStatus = laneStatusMap.get(laneID).laneStatusName;
  useEffect(() => {
    if (tempSellerAction === 'TAKES') {
      const highBid = auction[laneID].currentBid;
      if (highBid > 0) {
        takeAmountRef.current.value = highBid;
      }
      takeAmountRef.current.select();
      setTempSellerAction(auctionId, laneID, 'TAKES', highBid);
    }
    // eslint-disable-next-line
  }, [tempSellerAction]);


  useEffect(() => {
    if (!auction[laneID]?.isOpenForBidding) {
      if (sellerAction) {
        clearSellerAction(auctionId, laneID, sellerAction, false);
      }
    }
    // eslint-disable-next-line
  }, [auction[laneID]?.isOpenForBidding]);

  const [animationKey, setAnimationKey] = useState(0);

  useEffect(() => {
    // Reset animation when the countdownKey changes
    setAnimationKey((prev) => prev + 1);
  }, [countdownKey]);

  const getToolTip = (watched) => {
    if (watched) return 'You are watching this item.';
    return '';
  };

  const sellerStuff = () => !decisionStatus?.message && isSeller && (
  <Track className="reserve-takes" isMobileView={isMobileView} height={isFullViewLayout ? '35px' : '10px'}>
    <TrackKey isMobileView={isMobileView}>
      {(sellerAction === 'TAKES' || tempSellerAction === 'TAKES') ? 'Takes  ' : 'Reserve'}
      {(sellerAction === 'TAKES' || tempSellerAction === 'TAKES') && <span title={TakesValidationMessages()}><Icon icon="info-circle" size={1.1} iconOnly /></span> }
    </TrackKey>

    {(!tempSellerAction && (sellerAction?.includes('CANCEL') || !sellerAction)) && (
    <TrackValue data-testid="reserve-amt" color="var(--sellerReserveTextColor)" isMobileView={isMobileView}>
      {formattedReserve}
    </TrackValue>
    )}

    {sellerAction === 'PASS' && (
    <TrackValue data-testid="pass-value" color="var(--noSaleMsgBgColor)">
      PASS
    </TrackValue>
    )}

    {sellerAction === 'SELL' && (
      <TrackValue data-testid="reserve-amt" color="var(--sellerOkToSellBgColor)">
        OKAY TO SELL
      </TrackValue>
    )}

    {(tempSellerAction === 'TAKES' || sellerAction === 'TAKES') && (
    <TrackValue data-testid="reserve-amt" color="var(--sellerReserveTextColor)">
      {sellerAction === 'TAKES' ? `$ ${new Intl.NumberFormat().format(highBidAmtTakeClick)}` : (
        <InputButtonGroup showInput isFullViewLayout={isFullViewLayout}>
          <input
            style={DisableTakeSubmit().disabled ? { border: '1px solid var(--sellerReserveTextColor)' } : null}
            ref={takeAmountRef}
            autoComplete="off"
            tabIndex={-1}
            type="text"
            disabled={false}
            value={tempTakeAmount}
            onChange={(e) => setTempSellerAction(auctionId, laneID, 'TAKES', e.target.value)}
            maxLength={10}
            onKeyUp={onTakesKeyUp}
            onKeyPress={onTakesKeyPress}
          />
          <TakeButton
            disabled={DisableTakeSubmit().disabled}
            className="primary"
            onClick={() => setSellerAction(auctionId, laneID, 'TAKES', tempTakeAmount)}
          >
            OK
          </TakeButton>

          <TakeButton
            className="primary"
            onClick={() => {
              takeAmountRef.current.value = 0;
              setTakeAmountRefFocus();
              takeAmountRef.current.select();
            }}
          >
            X
          </TakeButton>
        </InputButtonGroup>
      )}
    </TrackValue>
    )}
  </Track>
  );

  if (isVirtual && !isSeller) {
    return (
        <ContentWrapper>
          <ElaneBidDetails
              decisionStatus={decisionStatus}
              wasOutbid={wasOutbid}
              productName={productName}
              key={countdownKey}
              highBidder={abbrevBidderName || "No bids yet"}
              highBid={auction[laneID].currentBid}
              nextBid={auction[laneID].nextBid}
              timeRemaining={duration}
              bidButtonText={BidButtonLabelLogic()}
              isWatched={isWatched}
              isBonusTime={isBonusTimeActive}
              isCountdownActive={isCountdownActive}
              isCurrentUserHighBidder={user.name === winningBidderName}
              isDisabled={disabledButton}
              lotNumber={productItem?.lotNumber}
              winningBidderName={winningBidderName}
              currentBidder={auction[laneID]?.bidder}
              auctionId={auctionId}
              laneID={laneID}
              onBid={() => placeLiveBid(
                  auctionId,
                  laneID,
                  auction[laneID].syncID,
                  auction[laneID].nextBid,
                  isVirtual
              )}
          />
        </ContentWrapper>
    )
  }

  return (
    <ContentWrapper
      isWatched={isWatched}
      showProxy={hasProxyBid}
      isSeller={isSeller}
      title={getToolTip(isWatched)}
      themeCss={theme}
    >
      <DetailsContainer isMobileView={isMobileView} isSeller={isSeller} isFullViewLayout={isFullViewLayout} isLightTheme={isLightTheme}>

        <Track className="high-bidder-container" isMobileView={isMobileView} isSeller={isSeller}>
          <TrackKey isMobileView={isMobileView} isWatched={isWatched}>High Bidder</TrackKey>
          <TrackValue
            data-testid="high-bidder"
            color={auction[laneID].bidder === state.bidder ? 'var(--red-2)' : 'var(--darkTextColor)'}
            isMobileView={isMobileView}
          >
            <div style={{
              minWidth: '100%', width: '100%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden',
            }}
            >
              {abbrevBidderName === winningBidderName ? (
                winningBidderName
              ) : (
                <span title={winningBidderName}>
                  {abbrevBidderName}
                </span>
              )}
            </div>

          </TrackValue>
        </Track>

        <Track className="high-bid-container" isMobileView={isMobileView}>
          <TrackKey isMobileView={isMobileView}>High Bid</TrackKey>
          <TrackValue color="var(--bidBtnBgColor)" data-testid="high-bid" isMobileView={isMobileView}>
            {auction[laneID].currentBid
              ? `$ ${new Intl.NumberFormat().format(
                auction[laneID].currentBid,
              )}`
              : 'N/A'}
          </TrackValue>
        </Track>
        {!isSeller && decisionStatus?.message && !isMobileView
          && (
          <FullTrackValue
            data-testid="bidder-status"
            isMobileView={isMobileView}
            bgColor={decisionStatus.bgColor}
            color={decisionStatus.color}
          >
            {decisionStatus?.message}
          </FullTrackValue>
          )}
        {sellerStuff()}
      </DetailsContainer>

      {/* FIXME: DO WE NEED THIS ASKING BID - DON'T THINK WE'RE USING IT (HIDDEN IN CSS) */}
      {!isMobileView && (
        <HighBidWrapper>
          <HighBidLabel>Asking Bid</HighBidLabel>
          {auction[laneID].nextBid ? (
            <HighBid data-testid="high-bid">
              $
              {new Intl.NumberFormat().format(auction[laneID].nextBid)}
            </HighBid>
          ) : (
            <NoBids data-testid="no-bid">Waiting</NoBids>
          )}
        </HighBidWrapper>
      )}

      {!isSeller && isMobileView && decisionStatus?.message
      && (
          <FullTrackValue
              data-testid="bidder-status"
              isMobileView={isMobileView}
              bgColor={decisionStatus.bgColor}
              color={decisionStatus.color}
          >
            {decisionStatus?.message}
          </FullTrackValue>
      )}

      {connected && !isSeller && !decisionStatus?.message && (
        myProxyBidIsActive ? (
          <ProxyBidButton data-testid="proxybid-btn" disabled={lanePaused} isFullViewLayout={isFullViewLayout} warning>
            {lanePaused ? 'Paused' : `MY PROXY $ ${new Intl.NumberFormat().format(myProxyBidAmount)}`}
          </ProxyBidButton>
        ) : (
          isMobileView ? (
            <div>
              {scrollPosition < 350 && (
                  <DoubleTapButton
                action={(frozenBid) => placeLiveBid(
                    auctionId,
                laneID,
                auction[laneID].syncID,
                    frozenBid,
                    isVirtual
                )}
                disabled={disabledButton}
                text={BidButtonLabelLogic()}
                nextBid={auction[laneID].nextBid}
                bidPanel
                />
              )}

              {/*<NewSwipeButton*/}
              {/*    key={Math.random()}*/}
              {/*    action={() => placeLiveBid(*/}
              {/*        laneID,*/}
              {/*        auction[laneID].syncID,*/}
              {/*        auction[laneID].nextBid,*/}
              {/*    )}*/}
              {/*    disabled={disabledButton}*/}
              {/*    text={BidButtonLabelLogic()}*/}
              {/*    bidPanel*/}
              {/*/>*/}
            </div>
          )
            : (
              <BidButton
                isFullViewLayout={isFullViewLayout}
                className="bid-btn"
                data-testid="bid-btn"
                disabled={disabledButton}
                duration={duration}
                success
                large
                onClick={() => placeLiveBid(
                    auctionId,
                  laneID,
                  auction[laneID].syncID,
                  auction[laneID].nextBid,
                    isVirtual
                )}
              >
                <span>{BidButtonLabelLogic()}</span>
              </BidButton>
            )
        )
      )}

      {connected && isSeller && <SellerTools auctionId={auctionId} />}

    </ContentWrapper>
  );
};

export default observer(BidDetails);
